import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import graphql from 'api/graphql';
import { fetchGigyaJWTPromise } from 'api/gigya';
import { TILE_SIZES, FAVORITE_ALL_PODCASTS_SLUG } from 'globalConst/const';
import Collection from 'components/Collection';
import EmptyStatePlaceholder from 'components/EmptyStatePlaceholder';
import { FAV_PODCASTS_TITLE, FAV_PODCASTS_SUBTITLE, FAV_PODCASTS_TEXT } from './FavoriteCollection.const';
import { TILE_COMPONENT_TYPES } from 'components/TileComponent/TileComponent.const';
import logger from 'util/logger';

function FavoritePodcastsCollection({ podcasts, isUserLoggedIn }) {
  const [favoritePodcasts, setFavoritePodcasts] = useState(null);
  useEffect(() => {
    let unmounted;
    async function fetchPodcasts() {
      try {
        const jwtToken = await fetchGigyaJWTPromise();
        const gqlFavsPodcasts = await graphql.fetchFavoritePodcasts(jwtToken, FAVORITE_ALL_PODCASTS_SLUG);
        if (!unmounted) setFavoritePodcasts(gqlFavsPodcasts || []);
      } catch (error) {
        logger.error('[FavoritePodcastsCollection] Failed to fetch favorite podcasts from Universal API.', error);
      }
    }
    if (isUserLoggedIn) {
      fetchPodcasts();
    }
    return () => {
      unmounted = true;
    };
  }, [podcasts, isUserLoggedIn]);

  return !isUserLoggedIn || (favoritePodcasts && favoritePodcasts.length === 0) ? (
    <EmptyStatePlaceholder title={FAV_PODCASTS_TITLE} subtitle={FAV_PODCASTS_SUBTITLE} text={FAV_PODCASTS_TEXT} />
  ) : (
    <Collection
      collectionId="favoritePodcasts"
      items={favoritePodcasts}
      title={FAV_PODCASTS_TITLE}
      rows={1}
      showCount
      tileComponent={TILE_COMPONENT_TYPES.PODCAST}
      swipe
      isComponentLoading={!favoritePodcasts}
      tileSizes={TILE_SIZES.SMALL}
    />
  );
}

FavoritePodcastsCollection.propTypes = {
  isUserLoggedIn: PropTypes.bool.isRequired,
  podcasts: PropTypes.array.isRequired,
};

export default FavoritePodcastsCollection;
